import './ScoreCarousel.scss';
import { usePortContext } from '../../../service/MessageChannelContext';

const scoreOrder = ['skinHealth', 'acne', 'texture', 'poreSize', 'darkSpots', 'brightness'];

const getScoreClassName = (score) => {
  if (score <= 4) {
    return 'red';
  }
  if (score <= 7) {
    return 'yellow';
  }
  return 'green';
};

const CONTENT = {
  skinHealth: {
    en: 'Skin Health',
    id: 'Kesehatan Kulit',
  },
  acne: {
    en: 'Acne',
    id: 'Jerawat',
  },
  texture: {
    en: 'Texture',
    id: 'Tekstur',
  },
  poreSize: {
    en: 'Pore Size',
    id: 'Ukuran Pori',
  },
  darkSpots: {
    en: 'Dark Spots',
    id: 'Dark Spots',
  },
  brightness: {
    en: 'Brightness',
    id: 'Kulit Kemerahan',
  },
};

const ScoreCard = ({ score, title, key, onSelect, isSelected }) => {
  return (
    <div className={`score-carousel-card ${isSelected ? 'selected' : ''}`} onClick={() => onSelect(key)}>
      <div className={`score-carousel-score ${getScoreClassName(score)}`}>
        <div>{score}/10</div>
      </div>
      <div className="score-carousel-title">{title}</div>
    </div>
  );
};

export const ScoreCarousel = ({ selectedMetric, setSelectedMetric, scores }) => {
  const { lang } = usePortContext();

  return (
    <div className="score-carousel">
      {scoreOrder.map((key) => (
        <ScoreCard
          key={key}
          score={scores[key]}
          title={CONTENT[key][lang]}
          onSelect={() => setSelectedMetric(key)}
          isSelected={selectedMetric === key}
        />
      ))}
    </div>
  );
};
